module.exports = __webpack_public_path__ + "static/media/fan-3.aac50a87.png";